import { Footer } from '@mantine/core';
import { FC, ReactNode } from 'react';
import { BrowserS } from '../../../Service/BrowserS';

const BookitupFooter: FC<{ children: ReactNode }> = ({ children }) => (
  <Footer height={BrowserS.runningAsPWA ? 85 : 60}>{children}</Footer>
);

export default BookitupFooter;
